// import axios from 'axios'

// const apiUrl = process.env.REACT_APP_API
// console.log('apiUrl', apiUrl)

// export const apiClient = axios.create({
//   baseURL: apiUrl,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// })

import axios from 'axios'
import { getAuth } from 'firebase/auth'
import { API_URL } from '../constants/env'

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 🔐 Attach token to every request
apiClient.interceptors.request.use(
  async (config) => {
    const skipAuthUrls = ['/zones/check']

    if (config.url && skipAuthUrls.some((url) => config.url?.startsWith(url))) {
      return config // skip token
    }

    const auth = getAuth()
    const user = auth.currentUser

    if (user) {
      const token = await user.getIdToken()
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
